// extracted by mini-css-extract-plugin
module.exports = {"ProductCard":"ProductCard_ProductCard__2u85d","ProductImage":"ProductCard_ProductImage__3ThHj"};